module.exports = __webpack_public_path__ + "static/img/shatter_logo.54896fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shatter_logo.png
// module id = 324
// module chunks = 1